var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoSimac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 116.5 30",
    style: {
      enableBackground: "new 0 0 116.5 30"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E0007E;}\r\n\t.st1{fill:#009CA2;}\r\n\t.st2{fill:none;}\r\n\t.st3{enable-background:new    ;}\r\n\t.st4{fill:#4B4A4A;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fondo"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "medidas"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_7"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1_00000070118794402414187070000003094295501395678121_"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_6"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.5,13.2C21.4,10.8,19.4,8.9,17,9c-2.4,0-4.3,2-4.3,4.4c0,0.7,0.2,1.4,0.5,2.1l0,0l0,0 c0.1,0.2,0.2,0.4,0.3,0.5l3.5,5.5l3.5-5.5c0.1-0.2,0.2-0.3,0.3-0.5l0,0l0,0C21.4,14.7,21.6,14,21.5,13.2z M17.3,14.7 c-0.8,0-1.4-0.6-1.4-1.4s0.6-1.4,1.4-1.4s1.4,0.6,1.4,1.4S18.1,14.7,17.3,14.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.7,25.2h-13c-2,0-3.6-1.6-3.6-3.6v-13c0-2,1.6-3.6,3.6-3.6h13c2,0,3.6,1.6,3.6,3.6v13 C27.3,23.5,25.6,25.2,23.7,25.2z M10.7,7.1c-0.8,0-1.5,0.7-1.5,1.5v13c0,0.8,0.7,1.5,1.5,1.5h13c0.8,0,1.5-0.7,1.5-1.5v-13 c0-0.8-0.7-1.5-1.5-1.5C23.7,7.1,10.7,7.1,10.7,7.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.3,26.6h-2.2c-0.9,0-1.7-0.8-1.7-1.7V8.1c0-0.9,0.8-1.7,1.7-1.7h2.2v2.1h-1.9v16h1.9V26.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27,4H7.3c-1,0-1.8-0.8-1.8-1.7V0h2.1v1.9h19.1V0h2.1v2.2C28.8,3.2,28,4,27,4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27,26H7.3c-1,0-1.8,0.8-1.8,1.7V30h2.1v-1.9h19.1V30h2.1v-2.2C28.8,26.8,28,26,27,26z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.2,25.4H0v-2.1h1.9v-16H0V5.2h2.2C3.2,5.2,4,6,4,6.9v16.8C4,24.6,3.2,25.4,2.2,25.4z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 27.8,
    y: 5.6,
    className: "st2",
    width: 99.1,
    height: 19.7
  }), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M48.6,19.2c0-0.8-0.3-1.3-0.8-1.7s-1.5-0.8-2.9-1.2s-2.5-0.9-3.3-1.4c-1.6-1-2.3-2.2-2.3-3.8 c0-1.4,0.6-2.5,1.7-3.4s2.6-1.3,4.4-1.3c1.2,0,2.2,0.2,3.2,0.7s1.7,1.1,2.2,1.9s0.8,1.7,0.8,2.7h-3c0-0.9-0.3-1.6-0.8-2.1 s-1.4-0.8-2.4-0.8c-1,0-1.7,0.2-2.3,0.6s-0.8,1-0.8,1.7c0,0.6,0.3,1.1,0.9,1.6s1.5,0.8,2.9,1.2s2.4,0.8,3.2,1.3s1.4,1.1,1.8,1.7 s0.6,1.4,0.6,2.3c0,1.4-0.5,2.6-1.6,3.4s-2.6,1.3-4.4,1.3c-1.2,0-2.4-0.2-3.4-0.7s-1.8-1.1-2.4-1.9s-0.9-1.7-0.9-2.8h3 c0,1,0.3,1.7,1,2.2s1.6,0.8,2.8,0.8c1,0,1.8-0.2,2.3-0.6S48.6,19.8,48.6,19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M58.3,23.6h-3V6.5h3V23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M66.8,6.5l4.9,13.1l4.9-13.1h3.8v17.1h-3v-5.6l0.3-7.5l-5,13.1h-2.1l-5-13.1l0.3,7.5v5.6h-3V6.5H66.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M94.5,19.6h-6.6l-1.4,4h-3.1l6.4-17.1h2.7L99,23.6h-3.1L94.5,19.6z M88.7,17.2h4.9l-2.5-7.1L88.7,17.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M114.9,18c-0.2,1.8-0.8,3.2-2,4.3s-2.7,1.5-4.7,1.5c-1.4,0-2.6-0.3-3.6-1s-1.8-1.6-2.4-2.7s-0.9-2.6-0.9-4.1 v-1.6c0-1.6,0.3-3,0.9-4.3s1.4-2.2,2.5-2.8s2.3-1,3.7-1c1.9,0,3.4,0.5,4.5,1.5s1.8,2.5,2,4.3h-3c-0.1-1.2-0.5-2.1-1.1-2.7 s-1.4-0.8-2.5-0.8c-1.3,0-2.3,0.5-3,1.4s-1,2.3-1.1,4.1v1.5c0,1.8,0.3,3.3,1,4.2s1.6,1.5,2.9,1.5c1.2,0,2-0.3,2.6-0.8 s1-1.4,1.1-2.6H114.9z"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Capa_4"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "etiquetas"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSimac);
export default __webpack_public_path__ + "static/media/Logo_SIMAC.59a62804bff9bdfdfe443950b7249c9d.svg";
export { ForwardRef as ReactComponent };